import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { FormloginService } from '../../services/formlogin.service';
import { ChangeService } from '../../services/change.service';
import { SesionService } from '../../services/sesion.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-formlogin',
  templateUrl: './formlogin.component.html',
  styleUrls: ['./formlogin.component.scss']
})
export class FormloginComponent implements OnInit {
  @Input() clase: any;
  @Input() change: any;

  public linkTerminos = environment.urlTerminosYCondiciones;
  public linkPoliticaPrivacidad = environment.urlPoliticaPrivacidad;

  constructor(
    public content: ProductService,
    public login: FormloginService,
    public cs: ChangeService,
    public sesion: SesionService
  ) {
  }

  ngOnInit() {
    this.login.change = this.change;
  }

}
